import {MessageHistory} from "../chat/messageHistory";
import {MessageHistoryMessage} from "../chat/messageHistoryMessage";

export class MessageHistoryFactory {
    static create(
        data: any
    ): null|MessageHistory {
        let history = new MessageHistory();

        let messages = data.messages;
        if (!Array.isArray(messages)) {
            return null;
        }

        messages.forEach(item => {
            if (!item || typeof item.senderName !== 'string' || typeof item.message !== 'string') {
                return;
            }

            let sender = item.sender;
            let name = item.senderName;
            let time = new Date(item.time);
            let message = item.message;
            let messageId = item.messageId;
            let responseId = item.responseId;
            let feedbackState = item.feedbackState;

            if (sender !== 'USER_MESSAGE' && sender !== 'AGENT_MESSAGE') {
                return;
            }

            if (isNaN(time.getTime())) {
                return;
            }

            let historyMessage = new MessageHistoryMessage(sender, name, time, message, messageId, responseId, feedbackState);
            history.addMessage(historyMessage);
        });

        return history;
    }
}
